import AbstractSpecification from "./AbstractSpecification.js";

/**
 * `notSpecification` is a concrete implementation
 * of `abstractSpecification` representing a server side
 * `not` operation for a specification.
 *
 * @param {abstractSpecification} spec.specification - Negated specification
 */
export default class NotSpecification extends AbstractSpecification {
	constructor(spec = {}) {
		super(spec);
		this._specification = spec.specification;
	}

	getSpecification() {
		return this._specification;
	}

	leaves() {
		return this._specification.leaves();
	}

	isNot() {
		return true;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitNotSpecification(this, additionalInformation);
	}

	_serializedProperties() {
		const schema = super._serializedProperties();

		schema.specification = this._specification;

		return schema;
	}

	static getType() {
		return "NotSpecification";
	}

	static transformMaterializationData(data, context) {
		data.specification = context.factory.materialize(data.specification);
	}
}
